import { useEffect, useMemo, useState } from 'react'
import { useMediaQuery } from 'react-responsive'

function readStoredIsDark(): boolean | undefined {
  const localIsDark = localStorage.getItem('colorScheme')
  return localIsDark === null ? undefined : localIsDark === 'true'
}

export function useColorScheme() {
  const systemPrefersDark = useMediaQuery(
    {
      query: '(prefers-color-scheme: dark)',
    },
    undefined
  )
  const [isDark, setIsDark] = useState<boolean | undefined>(readStoredIsDark)

  const handleSetIsDark = (newIsDark: boolean) => {
    localStorage.setItem('colorScheme', newIsDark.toString())
    setIsDark(newIsDark)
  }

  const value = useMemo(() => isDark ?? systemPrefersDark, [isDark, systemPrefersDark])

  useEffect(() => {
    if (value) {
      document.body.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
    }
  }, [value])

  return {
    isDark: value,
    setIsDark: handleSetIsDark,
  }
}
